import React, { useState, useEffect } from 'react';

import { Container, QuestionsContainer, PageTitle, Table } from '../components/tables/Style'
import { AddButton, DeleteButton } from '../components/tables/Buttons'
import { InputArea } from './Styles/Inputs';

import { getAllCollection, addToCollection, deleteFromCollection } from '../services/database';
// import { createUser, deleteUser } from '../services/users'

const UserSubscriptions = () => {
    //State
    const [rows, setRows] = useState([]);
    const [showAddRow, setShowAddRow] = useState(false);
    const [inputs, setInputs] = useState({
        title: '',
        description: '',
        displayed: false,
    });

    useEffect(() => {
        getAllCollection('user_subscriptions').then(result => {
            setRows(result.data);
        })
    }, []);

    //Functions
    const handleAddButton = () => {
        setShowAddRow(true);
    }

    const handleSaveButton = () => {
        if (inputs.description && inputs.title) {
            setShowAddRow(false);
            addToCollection(
                'user_subscriptions',
                (rows.length > 0 ? /*parseInt(rows[rows.length - 1].id)*/Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0
                ).toString(),
                {
                    id: rows.length > 0 ? /*parseInt(rows[rows.length - 1].id)*/Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0
                    ,
                    title: inputs.title,
                    description: inputs.description,
                    displayed: inputs.displayed
                }
            );
            getAllCollection('user_subscriptions').then(result => {
                setRows(result.data);
            })
            setInputs({
                title: '',
                description: '',
                displayed: false,
            });
        }
    }

    const handleDelete = (dateId) => {
        deleteFromCollection('user_subscriptions', dateId);
        getAllCollection('user_subscriptions').then(result => {
            setRows(result.data);
        })
    }

    return (
        <Container>
            <PageTitle>Korisnicke Pretplate</PageTitle>
            <QuestionsContainer>
                <AddButton onClick={() => handleAddButton()}>
                    <i className="fas fa-plus-circle"></i>
                    <h1>Dodaj</h1>
                </AddButton>
                <Table>
                    <tr>
                        <th style={{ width: '2%' }}>ID</th>
                        <th style={{ width: '36.5%' }}>Naziv</th>
                        <th style={{ width: '36.5%%' }}>Sadrzaj</th>
                        <th style={{ width: '10%' }}>Vidljiv?</th>
                        <th style={{ width: '15%' }}></th>
                    </tr>
                    <tr style={{ backgroundColor: '#222831', display: showAddRow ? 'revert' : 'none' }}>
                        <td>{rows.length > 0 ? /*parseInt(rows[rows.length - 1].id)*/Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0
                        }</td>
                        <td>
                            <InputArea
                                rows={8}
                                onChange={(e) => setInputs({ ...inputs, title: e.target.value })}
                                value={inputs.title}
                            />
                        </td>
                        <td>
                            <InputArea
                                rows={8}
                                onChange={(e) => setInputs({ ...inputs, description: e.target.value })}
                                value={inputs.description}
                            />
                        </td>
                        <td>
                            <select
                                onChange={(e) => setInputs({ ...inputs, displayed: e.target.value })}
                                value={inputs.displayed}
                            >
                                <option value={false} label={'Ne'} />
                                <option value={true} label={'Da'} />
                            </select>
                        </td>
                        <td>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                <AddButton onClick={() => handleSaveButton()}>
                                    <h1>Potvrdi</h1>
                                </AddButton>
                            </div>
                        </td>
                    </tr>
                    {rows.length > 0 ? rows.map(row =>
                        <tr key={'row_id_' + row.id}>
                            <td>{row.id}</td>
                            <td>{row.title}</td>
                            <td>{row.description}</td>
                            <td>{row.displayed ? 'Da' : 'Ne'}</td>
                            <td>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                    {/* <UpdateButton><i className="fas fa-edit"></i></UpdateButton> */}
                                    <DeleteButton onClick={() => handleDelete(row.id)}>
                                        <i className="fas fa-trash-alt"></i>
                                    </DeleteButton>
                                </div>
                            </td>
                        </tr>
                    )
                        : false
                    }
                </Table>
            </QuestionsContainer>
        </Container>
    )
}

export default UserSubscriptions;